import { useState } from "react";

export default function useTemplate(channel, templateType) {
	const [template, setTemplate] = useState(channel?.[templateType] || "");
	return [template, setTemplate];
}
